// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.useCaseLeftCol {
    border-right: 1px solid var(--integration-border-color);
    width: 25%;
}

.useCaseHeader {
    padding: 20px;
}

.useCaseHeader > *, .useCaseTable > * {
    align-self: center;
}

    .useCaseHeader > span, .sourceTableHeader {
        font-size: 16px;
        font-weight: 600;
        color: var(--integration-text-color);
    }

.useCaseIcon {
    height: 16px;
    width: 16px;
    margin-right: 10px;
    flex-shrink: 0;
}

.useCaseTableSearchDIV {
    padding: 20px;
    border-top: 1px solid var(--integration-border-color);
    border-bottom: 1px solid var(--integration-border-color);
    font-size: 15px;
}

.useCaseTableHeader {
    font-size: 14px;
    font-weight: 600;
    color: var(--integration-text-color);
}

.useCaseSource {
    font-size: 12px;
    color: var(--integration-light-text-color);
}

.useCaseTable {
    padding: 10px 20px;
    border-bottom: 1px solid var(--integration-border-color);;
}

.useCaseCount {
    width: 24px;
    height: 24px;
    font-size: 14px;
    color: var(--integration-background);
    background: var(--integration-text-color);
    border-radius: 6px;
    margin-left: 10px;
    flex-shrink: 0;
}

.sourceTableHeader {
    margin: 20px;
}

.useCaseTableHeaderCB {
    font-size: 14px;
    color: var(--integration-text-color);
}

.sourceTableDIV {
    margin-left: 20px;
}

.useCaseDataRow {
    font-size: 14px;
    color: var(--integration-light-text-color);
}

.useCaseTH {
    background-color: transparent;
}

.useCaseTableTextDIV {
    overflow: hidden;
}

.useCaseTableTextDIV > span,
.useCaseHeader > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smartintegrationwizard/siw.source.table.page.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;IAEI;QACI,eAAe;QACf,gBAAgB;QAChB,oCAAoC;IACxC;;AAEJ;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qDAAqD;IACrD,wDAAwD;IACxD,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".useCaseLeftCol {\n    border-right: 1px solid var(--integration-border-color);\n    width: 25%;\n}\n\n.useCaseHeader {\n    padding: 20px;\n}\n\n.useCaseHeader > *, .useCaseTable > * {\n    align-self: center;\n}\n\n    .useCaseHeader > span, .sourceTableHeader {\n        font-size: 16px;\n        font-weight: 600;\n        color: var(--integration-text-color);\n    }\n\n.useCaseIcon {\n    height: 16px;\n    width: 16px;\n    margin-right: 10px;\n    flex-shrink: 0;\n}\n\n.useCaseTableSearchDIV {\n    padding: 20px;\n    border-top: 1px solid var(--integration-border-color);\n    border-bottom: 1px solid var(--integration-border-color);\n    font-size: 15px;\n}\n\n.useCaseTableHeader {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--integration-text-color);\n}\n\n.useCaseSource {\n    font-size: 12px;\n    color: var(--integration-light-text-color);\n}\n\n.useCaseTable {\n    padding: 10px 20px;\n    border-bottom: 1px solid var(--integration-border-color);;\n}\n\n.useCaseCount {\n    width: 24px;\n    height: 24px;\n    font-size: 14px;\n    color: var(--integration-background);\n    background: var(--integration-text-color);\n    border-radius: 6px;\n    margin-left: 10px;\n    flex-shrink: 0;\n}\n\n.sourceTableHeader {\n    margin: 20px;\n}\n\n.useCaseTableHeaderCB {\n    font-size: 14px;\n    color: var(--integration-text-color);\n}\n\n.sourceTableDIV {\n    margin-left: 20px;\n}\n\n.useCaseDataRow {\n    font-size: 14px;\n    color: var(--integration-light-text-color);\n}\n\n.useCaseTH {\n    background-color: transparent;\n}\n\n.useCaseTableTextDIV {\n    overflow: hidden;\n}\n\n.useCaseTableTextDIV > span,\n.useCaseHeader > span {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
